import { render, staticRenderFns } from "./PopUpControlReceivedFile.vue?vue&type=template&id=3a0c6666&"
import script from "./PopUpControlReceivedFile.vue?vue&type=script&lang=js&"
export * from "./PopUpControlReceivedFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpControlReceivedFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0c6666')) {
      api.createRecord('3a0c6666', component.options)
    } else {
      api.reload('3a0c6666', component.options)
    }
    module.hot.accept("./PopUpControlReceivedFile.vue?vue&type=template&id=3a0c6666&", function () {
      api.rerender('3a0c6666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpControlReceivedFile.vue"
export default component.exports